export const DOLLAR_DECIMALS = 1;
